import { RESET_PASSWORD_FAILURE } from './Constants';

export const translationKeyMap: Record<string, string> = {
    acceptAllTermsAndConditionsLabel: 'accept_all_terms_conditions',
    acceptLoyaltyLabel: 'accept_loyalty',
    acceptThirdPartyPrivacyPolicyLabel: 'accept_third_party_privacy_policy',
    acceptUseOfPersonalInformationLabel: 'accept_use_of_personal_information',
    acceptUseOfPersonalInformationRequiredMessage: 'accept_use_of_personal_information_required',
    accountSignupErrorComplete: '',
    accountSignupErrorPartial: '',
    addressRequiredMessage: 'address_required',
    ageConsentRequiredMessage: 'age_consent_required',
    ageGroupLabel: 'age_group',
    agreeRequiredMessage: 'agree_required',
    alreadyConnectedFailureMessage: 'already_connected_failure_message',
    mobileNumberMissingErrorMessage: 'mobile_number_missing',
    mobileCountryCodeNotAllowedMessage: 'mobile_country_code_not_allowed',
    alreadyRegisteredMessage: 'elc_account_errors.already_registered',
    alreadyRegisteredPleaseSignInMessage: 'already_registered_please_sign_in',
    badLabel: 'bad',
    birthday: 'birthday',
    birthDayLabel: 'birth_day',
    birthDayRequiredMessage: 'birth_day_required',
    birthdayOptionalLabel: 'birthday_optional',
    birthMonthLabel: 'birth_month',
    birthMonthRequiredMessage: 'birth_month_required',
    birthYearLabel: 'birth_year',
    changeEmailTitle: 'change_email',
    changeMobile: 'change_mobile',
    cityLabel: 'city',
    cityRequiredMessage: 'city_required',
    completeSignUpGenericErrorMessage: 'complete_signup_generic',
    completeUserExistsErrorMessage: 'complete_user_exists',
    connectWithLine: 'elc_account.connect_with_line',
    contactPreferenceContent: 'contact_preference_content',
    contactPreferenceTitle: 'contact_preference_title',
    continueCheckoutLabel: 'continue_checkout',
    continueLabel: 'continue',
    continueWithFacebook: 'continue_with_facebook',
    continueWithFacebookPolicy: 'continue_with_facebook_policy',
    continueWithLine: 'elc_account.continue_with_line',
    continueWithSocialConsent: 'continue_with_social_consent',
    countryCodeLabel: 'country_code',
    createAccountConsent: 'create_account_consent',
    createAccountLabel: 'create_account',
    dateDay: 'day',
    dateMonth: 'month',
    dateYear: 'year',
    districtLabel: 'district',
    emailAddressInvalidMessage: 'email_address_invalid',
    emailAddressRequiredMessage: 'email_address_required',
    emailLabel: 'email',
    emailMeCodeToSignIn: 'email_me_a_code_to_sign_in',
    emailOptIn: 'email_optin',
    emailMissingErrorMessage: 'email_missing',
    emailRegistration: 'email_registration',
    emailRequiredMessage: 'email_required',
    emailValidMessage: 'email_invalid',
    enterEmailOtpInstructions: 'enter_email_otp_instructions',
    enterVerificationCode: 'enter_verification_code',
    enterYourEmailAddress: 'enter_your_email_address',
    existingAccountFoundPleaseSignIn: 'existing_account_found_please_sign_in',
    existingAccountFoundWithMobilePleaseSignIn: 'existing_account_found_with_mobile_please_sign_in',
    fieldContainsBadCharError: 'field_contains_bad_characters',
    firstLineAddressLabel: 'first_line_address',
    firstNameAlternateLabel: 'first_name_alternate',
    firstNameAlternateRequired: 'first_name_alternate_required',
    firstNameInvalidMessage: 'first_name_invalid',
    firstNameLabel: 'first_name',
    firstNameRequired: 'first_name_required',
    forgotPasswordLabel: 'forgot_password',
    fullNameLabel: 'full_name',
    fullNameRequired: 'full_name_required',
    genericError: 'generic_error',
    goBack: 'go_back',
    guestCheckoutConsent: 'guest_checkout_consent',
    guestCheckoutLabel: 'guest_checkout',
    inviteYouToJoinLine: 'elc_account.invite_you_to_join_line',
    lastNameAlternateLabel: 'last_name_alternate',
    lastNameAlternateRequired: 'last_name_alternate_required',
    lastNameInvalidMessage: 'last_name_invalid',
    lastNameLabel: 'last_name',
    lastNameRequired: 'last_name_required',
    loadingLabel: 'elc_general.loading',
    loyaltyTermsLink: 'elc_common.loyalty_terms_link',
    mandatoryFieldsLabel: 'mandatory_fields',
    marketingEmailConsent: 'marketing_email_consent',
    marketingSmsConsent: 'marketing_sms_consent',
    mediumLabel: 'medium',
    mobileNumber: 'mobile_number',
    mobileNumberLabel: 'mobile_number',
    mobileNumberRegistered: 'mobile_number_registered',
    mobileNumberRequiredMessage: 'mobile_number_required',
    mobileNumberValidMessage: 'mobile_number_invalid',
    monthOutOfRangeError: 'month_out_of_range',
    needHelpWithYourPassword: 'need_help_with_your_password',
    newPassword: 'new_password',
    optInAllLabel: 'opt_in_all',
    optInDirectMailLabel: 'opt_in_direct_mail',
    optInEmailLabel: 'opt_in_email',
    optInPhoneCallLabel: 'opt_in_phone_call',
    optInSmsLabel: 'opt_in_sms',
    optOutLabel: 'opt_out',
    or: 'or',
    orFillInTheForm: 'or_fill_in_the_form',
    otpCodeExpired: 'otp_code_expired',
    otpCodeSent: 'otp_code_sent',
    otpFailedToVerify: 'otp_failed_to_verify',
    otpGenericErrorMessage: 'otp_generic_error',
    otpInstruction: 'otp_instruction',
    otpInvalidCode: 'otp_invalid_code',
    otpLength: 'otp_length',
    otpNotReceiveCode: 'otp_not_receive_code',
    otpResendBlocked: 'otp_resend_blocked',
    otpResendCode: 'otp_resend_code',
    otpServerErrorMessage: 'otp_server_error',
    otpSwitchToEmail: 'otp_switch_to_email',
    otpSwitchToSms: 'otp_switch_to_sms',
    otpTooManyAttempts: 'otp_too_many_attempts',
    partialSignUpGenericErrorMessage: 'partial_signup_generic',
    passwordHint: 'password_hint',
    passwordInvalidError: 'password_invalid',
    passwordLabel: 'password',
    passwordLengthRequirementLabel: 'password_length_requirement',
    passwordLowerCharacterLabel: 'password_lower_character',
    passwordNumberRequirementLabel: 'password_number_requirement',
    passwordRequiredMessage: 'password_required',
    passwordRequirementsLabel: 'password_requirements',
    passwordStrength: 'password_strength',
    passwordStrengthFailedResetPasswordError: 'password_strength_failed_reset_password',
    passwordUpperCharacterLabel: 'password_upper_character',
    postalCodeLabel: 'postal_code',
    postalCodeRequiredMessage: 'postal_code_required',
    privacyPolicyDisclaimer: 'privacy_policy_disclaimer',
    privacyPolicyLink: 'privacy_policy_link',
    qrcodeText: 'qrcode_text',
    qrcodeTitle: 'qrcode_title',
    reachBALabel: 'reach_ba',
    reachBAText: 'elc_common.reach_ba_text',
    resendCodeInMinutes: 'resend_code_in_minutes',
    [RESET_PASSWORD_FAILURE]: 'reset_password_failure',
    resetPasswordNewPassword: 'reset_password_new_password',
    resetPasswordSubtitle: 'reset_password_subtitle',
    resetPasswordAction: 'reset_password_action',
    reviewPrivacyNoticeLabel: 'review_privacy_notice',
    salutationLabel: 'salutation',
    savePasswordAndSignIn: 'save_password_and_sign_in',
    secondLineAddressLabel: 'second_line_address',
    selectLabel: 'select',
    sexLabel: 'sex',
    signInAndEnrollToLoyalty: 'elc_account.sign_in_and_enroll_to_loyalty',
    signInLabel: 'sign_in',
    signInOnlineAccountLabel: 'sign_in_online_account',
    signInTermsConsent: 'sign_in_terms_consent',
    signInToConnectSocial: 'sign_in_to_connect_social',
    signInToContinue: 'elc_account.sign_in_to_continue',
    socialSignUpWithSSG: 'social_sign_up_with_ssg',
    socialSignUpWithKKG: 'social_sign_up_with_kkg',
    signUpLabel: 'sign_up',
    signUpText: 'signup_text',
    smsPromotions: 'sms_promotions',
    socialAccountRegistration: 'social_account_registration',
    socialSignInFailureMessage: 'social_sign_in_failure_message',
    stateLabel: 'state',
    stateRequiredMessage: 'state_required',
    storeList: 'store_list',
    stores: 'stores',
    storesRequiredMessage: 'stores_required',
    strongLabel: 'strong',
    submitLabel: 'submit',
    systemError: 'elc_errors.system_error',
    TBD: 'TBD',
    termsConditionsLink: 'terms_condition_link',
    termsConditionsLoyaltyLabel: 'terms_conditions_loyalty',
    termsConditionsRequiredError: 'terms_conditions_required_error',
    thirdLineAddress: 'third_line_address',
    tryAgain: 'elc_general.try_again',
    verifySocialEmail: 'verify_social_email',
    weakLabel: 'weak',
    welcomeLabel: 'welcome',
    yearOutOfRangeError: 'year_out_of_range'
};
